import { render } from "./BorderBottomRightRadius.vue?vue&type=template&id=5c51fd95&scoped=true&ts=true"
import script from "./BorderBottomRightRadius.vue?vue&type=script&lang=ts"
export * from "./BorderBottomRightRadius.vue?vue&type=script&lang=ts"

import "./BorderBottomRightRadius.vue?vue&type=style&index=0&id=5c51fd95&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c51fd95"]])

export default __exports__